import Skeleton from "react-loading-skeleton";
import styles from "./consumptionCompareContent.module.scss";

export const ConsumptionCompareLoadingContent = () => {
	return (
		<div className={styles.wrapper}>
			<hr className={styles.divider} />
			<Skeleton width="55%" height={16} style={{ marginBottom: 8 }} />
			<Skeleton count={2} height={13} style={{ marginBottom: 4 }} />
			<hr className={styles.divider} />
			<div className={styles.metricsRow}>
				<div className={styles.metricGroup}>
					<Skeleton width={80} height={13} />
					<Skeleton width={70} height={22} />
				</div>
				<div className={styles.metricGroup}>
					<Skeleton width={120} height={13} />
					<Skeleton width={70} height={22} />
				</div>
				<Skeleton width={60} height={28} borderRadius={100} style={{ marginLeft: "auto" }} />
			</div>
			<hr className={styles.divider} />
			<Skeleton height={140} />
		</div>
	);
};
